import { MoveRight, PhoneCall, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

function SmallHero() {
  return (
    <div className="w-full py-16 lg:py-32 bg-transparent">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 gap-8 items-center lg:grid-cols-2">
          <div className="flex gap-4 flex-col">
            <div>
              <Badge variant="success" className="uppercase text-xs tracking-wider">Cost-Effective Solutions</Badge>
            </div>
            <div className="flex gap-4 flex-col">
              <h1 className="text-4xl md:text-6xl max-w-lg tracking-tighter text-left font-medium">
                Turning Regulatory Burden into
                <span className="bg-gradient-to-r from-[#184c06] via-[#1b6504] to-[#229302] bg-clip-text text-transparent block mt-2">
                  Competitive Advantage
                </span>
              </h1>
              <p className="text-lg leading-relaxed tracking-tight text-muted-foreground max-w-md text-left">
                We build tailored AI-powered compliance workflows customized for your specific industry needs, eliminating overlapping requirements across multiple directives. Our platform reduces costs by 65%, slashes error rates by 86%, and helps you regain 240+ hours annually.
              </p>
            </div>

            <div className="mt-4 text-sm text-gray-500">
              <span className="font-medium text-[#1b6504]">ENTERPRISE PRICING:</span> Up to 45% less than competitors for enterprise compliance automation
            </div>
          </div>
          <div className="bg-white rounded-md overflow-hidden shadow-xl border border-gray-100">
            <img
              src="/screens/dash2.png"
              alt="Custom compliance workflow dashboard with AI insights"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export { SmallHero };